<mat-toolbar color="primary" *ngIf="showToolbar">
  <h1 mat-dialog-title>Terms and Conditions</h1>
</mat-toolbar>
<div class="mdc-mb-2">
  <app-flo-editor [text]="body" (textUpdated)="bodyUpdated($event)"></app-flo-editor>
</div>
<button mat-raised-button color="accent" *ngIf="!termsAndConditionsDefinition?.id" (click)="create()" [disabled]="!body">{{'ADD' | translate: {Default: 'Add'} }}</button>
<button mat-raised-button color="accent" *ngIf="termsAndConditionsDefinition?.id" (click)="update()">{{'UPDATE' | translate: {Default: 'Update'} }}</button>